import API from "../../utils/api";


export const getInventoryProductsApi = async (data) => {
    const response = await API.get(`product/inventory`,{
        params: data,
    });
    return { response };
};
export const updateInventoryApi = async (data,id) => {
    const response = await API.put(`product/inventory/`+id,data);
    return { response };
};

export const getInventoryHistoryDetailsApi = async (data) => {
    const response = await API.get(`product/inventory/history-details`, {
        params: data,
    });
    return { response };
};

export const exportInventoryHistoryDetailsApi = async (data) => {
    const response = await API.get(`product/inventory/history-details/export`, {
        params: data,
    });
    return { response };
};
